/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Login from "views/pages/access/Login.js"
import Profile from "views/pages/access/Profile.js"
import Register from "views/pages/access/Register.js"
import SmartChatPage from "views/pages/SmartChatPage.js"

var routes = [
  {
    path: "/smart-chat",
    name: "SmartChat",
    icon: "ni ni-chat-round text-primary",
    component: SmartChatPage,
    layout: "/admin",
    sideBar: true,
  },
  {
    collapse: true,
    name: "Access",
    icon: "ni ni-ungroup text-orange",
    state: "accessCollapse",
    views: [
      {
        path: "/login",
        name: "Login",
        miniName: "L",
        component: Login,
        layout: "/auth",
      },
      {
        path: "/register",
        name: "Register",
        miniName: "R",
        component: Register,
        layout: "/auth",
      },
      {
        path: "/profile",
        name: "Profile",
        miniName: "P",
        component: Profile,
        layout: "/admin",
      },
    ],
  },
];

export default routes;
